import apiService from '@/services/apiService';

const actions = {
  getImageURLGeneratorWithPaging({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('image-url-generator/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getImageURLGenerator({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`image-url-generator/find-by-id/${payload}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postImageURLGenerator({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('image-url-generator', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putImageURLGenerator({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`image-url-generator/update/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteImageURLGenerator({ commit }, payload) {
    return new Promise((resolve, reject) => {
    apiService.delete(`image-url-generator/delete/${payload}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
    });
  },
};

export default actions;